/* HENA.AX — carrito propio: reloj del cupón, barra al deslizar, sugeridos y aplicar cupón.
   Comparte el reloj con el popup de bienvenida (misma clave en localStorage). */
(function () {
  'use strict';
  var K = { ini: 'hx_bv_inicio', ok: 'hx_bv_ok', barra: 'hx_barra_cerrada' };
  function leer(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function guardar(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function dos(x) { return (x < 10 ? '0' : '') + x; }
  function fmt(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return dos(Math.floor(s / 60)) + ':' + dos(s % 60); }

  // Milisegundos que quedan (0 = terminó). crear = arranca el reloj si todavía no empezó.
  function restante(minutos, crear) {
    var dur = minutos * 60000, ahora = Date.now(), ini = parseInt(leer(K.ini) || '0', 10);
    if (ini && ahora - ini >= dur && ahora - ini >= 86400000) ini = 0;     // al día siguiente vuelve a ofrecerse
    if (!ini) { if (!crear) return 0; ini = ahora; guardar(K.ini, String(ini)); }
    var r = ini + dur - ahora; return r > 0 ? r : 0;
  }
  function cookieCupon() {
    var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
    try { return m ? decodeURIComponent(m[1]).toUpperCase() : ''; } catch (e) { return ''; }
  }
  function aplicado(codigo) { return !!codigo && cookieCupon() === String(codigo).toUpperCase(); }
  function ruta() { return window.location.pathname + window.location.search; }

  function pintar() {
    // --- bloque del cupón dentro del carrito ---
    document.querySelectorAll('[data-hx-cupon]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-minutos'), 10) || 10, cod = el.getAttribute('data-codigo');
      var abierto = !!el.closest('cart-drawer.active') || el.hasAttribute('data-pagina');
      var ya = el.hasAttribute('data-aplicado') || aplicado(cod), r = restante(min, abierto);
      el.hidden = !(r > 0 || ya);
      el.classList.toggle('is-aplicado', ya);
      var c = el.querySelector('[data-hx-cuenta]'); if (c) c.textContent = fmt(r);
    });
    // --- barra de abajo mientras se desliza ---
    var b = document.querySelector('[data-hx-barra]');
    if (b) {
      var minB = parseInt(b.getAttribute('data-minutos'), 10) || 10, codB = b.getAttribute('data-codigo');
      var rB = restante(minB, false), popup = document.getElementById('hx-bv');
      var popupAbierto = !!popup && !popup.hidden;
      var cerrada = false; try { cerrada = window.sessionStorage.getItem(K.barra) === '1'; } catch (e) {}
      var mostrar = rB > 0 && window.scrollY > 400 && !popupAbierto && !aplicado(codB) && !cerrada && !document.querySelector('cart-drawer.active');
      var cb = b.querySelector('[data-hx-cuenta]'); if (cb) cb.textContent = fmt(rB);
      var btn = b.querySelector('[data-hx-barra-btn]'), reclamado = !!leer(K.ok);
      if (btn) btn.textContent = reclamado ? btn.getAttribute('data-texto-usar') : btn.getAttribute('data-texto-pedir');
      if (mostrar) { b.hidden = false; requestAnimationFrame(function () { b.classList.add('is-visible'); }); }
      else if (!b.hidden) { b.classList.remove('is-visible'); setTimeout(function () { if (!b.classList.contains('is-visible')) b.hidden = true; }, 500); }
    }
  }

  function aplicarCupon(codigo, boton) {
    if (boton) boton.disabled = true;
    fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).then(function () {
      return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (s) {
        var drawer = document.querySelector('cart-drawer'); if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents({ sections: s }); }
      });
    }).catch(function () {}).then(function () { if (boton) boton.disabled = false; });
  }

  function agregarSugerido(id, boton) {
    var cont = boton.closest('.hx-up'), err = cont && cont.querySelector('[data-hx-up-error]');
    if (err) err.textContent = '';
    boton.disabled = true; boton.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status || !d.sections) throw new Error(d.description || d.message || 'No se pudo agregar');
      var drawer = document.querySelector('cart-drawer'); if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(d); }
    }).catch(function (e) {
      boton.disabled = false; boton.textContent = 'Agregar';
      if (err) err.textContent = (e && e.message) || 'No se pudo agregar. Probá de nuevo.';
    });
  }

  // ---- Conjuntos: agregar un conjunto sugerido (varios productos de una vez) ----
  function agregarConjunto(btn) {
    var ids = btn.getAttribute('data-hx-conj-agregar').split(',').filter(Boolean).map(Number), txt = btn.textContent;
    btn.disabled = true; btn.textContent = 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }), sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status || !d.sections) throw new Error(d.description || d.message || 'No se pudo agregar');
      var drawer = document.querySelector('cart-drawer'); if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(d); }
      btn.textContent = txt; btn.disabled = false;
    }).catch(function (e) { btn.textContent = (e && e.message) ? e.message.slice(0, 60) : 'No se pudo agregar'; setTimeout(function () { btn.textContent = txt; btn.disabled = false; }, 2500); });
  }

  // ---- Conjuntos: barra "Tu conjunto" en la colección ----
  function textoConjunto(n, p, aplicado) {
    if (n >= 2 && !aplicado) return 'Ya tenés una promo aplicada en tu carrito';
    if (n <= 0) return 'Llevá 2 productos y ahorrás ' + p[2] + '%';
    if (n === 1) return 'Sumá 1 más y llevate ' + p[2] + '% OFF';
    if (n === 2) return '¡' + p[2] + '% OFF aplicado! Sumá 1 más y pasás a ' + p[3] + '%';
    if (n === 3) return '¡' + p[3] + '% OFF aplicado! Sumá 1 más y pasás a ' + p[4] + '%';
    return '¡' + p[4] + '% OFF aplicado!';
  }
  var cartN = 0;
  function pintarConjunto() {
    var b = document.querySelector('[data-hx-cjb]'); if (!b) return;
    var p = { 2: +b.getAttribute('data-p2') || 10, 3: +b.getAttribute('data-p3') || 15, 4: +b.getAttribute('data-p4') || 20 };
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0, aplicado = false;
      c.items.forEach(function (i) {
        if (!i.gift_card) n += i.quantity;
        (i.discounts || []).forEach(function (d) { if (/conjunto/i.test(d.title)) aplicado = true; });
      });
      cartN = n;
      b.querySelector('[data-hx-cjb-msg]').textContent = textoConjunto(n, p, aplicado);
      b.querySelector('[data-hx-cjb-barra]').style.width = Math.min(100, Math.round(n * 25)) + '%';
      b.classList.toggle('is-listo', aplicado);
      var mostrar = (n > 0 || window.scrollY > 300) && !document.querySelector('cart-drawer.active');
      if (mostrar) { b.hidden = false; setTimeout(function () { b.classList.add('is-visible'); }, 30); }
      else if (!b.hidden) { b.classList.remove('is-visible'); setTimeout(function () { if (!b.classList.contains('is-visible')) b.hidden = true; }, 500); }
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var ap = t.closest('[data-hx-aplicar]');
    if (ap) { e.preventDefault(); var cc = ap.closest('[data-hx-cupon]'); if (cc) aplicarCupon(cc.getAttribute('data-codigo'), ap); return; }
    var tb = t.closest('[data-hx-talles-abrir]');
    if (tb) { e.preventDefault(); var dl = tb.closest('.hx-talles').querySelector('dialog'); if (dl && dl.showModal) dl.showModal(); return; }
    if (t.closest('[data-hx-talles-cerrar]')) { e.preventDefault(); var dc = t.closest('dialog'); if (dc) dc.close(); return; }
    if (t.matches && t.matches('dialog[data-hx-talles]')) { t.close(); return; }
    var cj = t.closest('[data-hx-conj-agregar]');
    if (cj) { e.preventDefault(); agregarConjunto(cj); return; }
    if (t.closest('[data-hx-abrir-carrito]')) { e.preventDefault(); var ic = document.querySelector('#cart-icon-bubble'); if (ic) ic.click(); return; }
    var up = t.closest('[data-hx-up-agregar]');
    if (up) { e.preventDefault(); agregarSugerido(up.getAttribute('data-hx-up-agregar'), up); return; }
    var bb = t.closest('[data-hx-barra-btn]');
    if (bb) {
      e.preventDefault();
      var barra = bb.closest('[data-hx-barra]'), cod = barra.getAttribute('data-codigo');
      if (leer(K.ok)) { window.location.href = '/discount/' + encodeURIComponent(cod) + '?redirect=' + encodeURIComponent(ruta()); }
      else if (typeof window.hxBvAbrir === 'function') { window.hxBvAbrir(); pintar(); }
      else { window.location.href = '/discount/' + encodeURIComponent(cod) + '?redirect=' + encodeURIComponent(ruta()); }
      return;
    }
    if (t.closest('[data-hx-barra-cerrar]')) { try { window.sessionStorage.setItem(K.barra, '1'); } catch (x) {} pintar(); }
  });

  window.addEventListener('scroll', function () { pintar(); }, { passive: true });
  document.addEventListener('DOMContentLoaded', pintar);
  setInterval(pintar, 1000);
  document.addEventListener('DOMContentLoaded', pintarConjunto);
  setInterval(pintarConjunto, 3000);
  var ultimoCj = 0;
  window.addEventListener('scroll', function () { if (Date.now() - ultimoCj > 1500 && document.querySelector('[data-hx-cjb]')) { ultimoCj = Date.now(); pintarConjunto(); } }, { passive: true });
})();
